import { getCookie, setCookie } from 'src/utils/cookies'

import type { EnvTier } from '../types'
import { randomUUID } from '../utils/randomUUID'

const COOKIE_ENV_NAME = 'dkt_statsig_env_tier'
const COOKIE_SESSION_NAME = 'dkt_statsig_session'

export function getStatsigUserId(): string {
  const isBrowser = typeof window !== 'undefined'

  if (!isBrowser) {
    return ''
  }

  const cookieName = COOKIE_SESSION_NAME
  const expiresInMinutes = 24 * 60

  let sessionId = getCookie(cookieName)

  if (!sessionId) {
    sessionId = randomUUID()
    setCookie(cookieName, sessionId, { expiresInMinutes })
  }

  return sessionId
}

export function getStatsigEnvTier(): EnvTier {
  const isBrowser = typeof window !== 'undefined'
  const envTierDefault = 'production'

  if (!isBrowser) {
    return envTierDefault
  }

  const cookieName = COOKIE_ENV_NAME

  const envTierCookie = getCookie(cookieName)

  if (!envTierCookie) {
    setStatsigEnvTier(envTierDefault)
  }

  if (envTierCookie) {
    return envTierCookie as EnvTier
  }

  return envTierDefault
}

export function setStatsigEnvTier(envTier: EnvTier) {
  const isBrowser = typeof window !== 'undefined'

  if (!isBrowser) {
    return undefined
  }

  const cookieName = COOKIE_ENV_NAME
  const expiresInMinutes = 24 * 60

  return setCookie(cookieName, envTier, { expiresInMinutes })
}
